/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1661
 */

var r = require(/* 86 */"./1650/86/index")
var o = require(/* 1262 */"./1785/1262")
r({
  target: "Object",
  stat: true,
  forced: Object.assign !== o
}, {
  assign: o
})
